export enum OfferTypeEnum {
	percentage = 1,
	bogo = 2,
	credit = 3,
	freeEntry = 4,
}
